// extracted by mini-css-extract-plugin
export default {"container":"TeamMemberDayTimeline_container__uPJcz"};